import React, { useState } from 'react';
import {Modal, Input } from 'antd';
import styles from "./cancelvideo.module.scss";
import { URButton } from '../../../../shared/widgets/button';
import ContactLoader from "../../../../styles/images/Lottie Animation.json";
import { sendCancelVideoCallRequest, sendDirectCancelVideoCallRequest, sendHostDirectCancelVideoCallRequest } from '../../../../base/callService/callService';
import Lottie from 'lottie-react';
import { profileDetails } from '../../../../models/model';
import { useSelector } from 'react-redux';



type createNoteProps = {
  open: boolean;
  openNote: (status: boolean) => void;
}
type CreateNoteState = {
  title: any;
  description: any;
  key:string;
  errors:boolean
}
export default function CancelVideoRequest({ open, openNote }: createNoteProps) {
  let { videomeetingDetails, isDirectVideocall}: profileDetails = useSelector((state: any) => state.profileReducer);
 

  const onCancel = () => {

    if(isDirectVideocall)sendHostDirectCancelVideoCallRequest(videomeetingDetails);
    else sendCancelVideoCallRequest(videomeetingDetails);
   
  };



  return (
    <>
      <Modal visible={open} className={`${styles.newmessage} ${"modaloverwrite"} ${"notecreation"}`}>
      
        <div className={`contentcentet ${styles.createNoteBody}`}>
        <Lottie width={150} className="modalloadingimg svgLoading forchatsvg"
                    animationData={ContactLoader} loop ={true} />
        <h2>Waiting to accept video meeting request...</h2>
        <URButton onClick={onCancel} name="Cancel Request" className="urButton buttonWhite" />
         
        </div>

      </Modal>
    </>
  );
}

